import { render, staticRenderFns } from "./ssiv-login-card.vue?vue&type=template&id=7ef3c05d"
import script from "./ssiv-login-card.vue?vue&type=script&lang=js"
export * from "./ssiv-login-card.vue?vue&type=script&lang=js"
import style0 from "./ssiv-login-card.vue?vue&type=style&index=0&id=7ef3c05d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports